<template>
  <div>
    <HeaderCreditor header="ใบ PU" :img_header="header_image" link_back="creditor/puinvoice"/>
    <PU_details_pr/>
  </div>
</template>

<script>
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";
import PU_details_pr from "@/components/admin/creditor/puinvoice/PU_details_pr";
import HeaderImage from "@/assets/billing.png";
export default {
  name: "PUdetailspr",
  components: {
    PU_details_pr,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
